import ActionTypes from '../constants';

const initialState = {
    colors: {},
    color: {},
    newColor: {}
    // loading: false,
};

const colorReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETCOLORSUCCESS:
            return {
                ...state,
                colors: action.payload,
            }
        case ActionTypes.GETCOLORBYIDSUCCESS:
            return {
                ...state,
                color: action.payload,
            }
        case ActionTypes.SAVECOLORSUCCESS:
            return {
                ...state,
                newColor: action.payload,
            }
        default:
            return state;
    }
}

export default colorReducer;